﻿/* globals FavoritosDTO */
var jquery = require("jquery");
var HabUtils = require("../../Global/habitaclia-utils");
var HabEvents = require("../../Global/habitaclia-events");


(function () {
    "use strict";

    var Favoritos = function (favoritosDTO) {
        this.__favoritosDTO = favoritosDTO;
        this.__isFicha = __isFicha.call(this);
        var currentUrl = document.location.toString();
        var prefix = this.__favoritosDTO.loginPage === 'login' ? '' : 'hab_usuarios/';

        /*jshint eqeqeq:false*/
        if (currentUrl.match(".htm" + "$") == ".htm") {
            this.__favoritosDTO.UrlLogin = "/" + prefix + this.__favoritosDTO.loginPage + "?redirect=" + encodeURIComponent(document.location.toString() + "?addFav=1");
        }
        else {
            this.__favoritosDTO.UrlLogin = "/" + prefix + this.__favoritosDTO.loginPage + "?redirect=" + encodeURIComponent(document.location.toString() + "&addFav=1");
        }

        this.__anchorElement = document.getElementById("linkFavorito");

        if (this.__favoritosDTO.FavoritoAction === 'removeFav') {
            if (this.__anchorElement.children.length > 1) {
                this.__anchorElement.children[0].classList.add("ocultar");
                this.__anchorElement.children[1].classList.remove("ocultar");
            }
        }
    };

    var __manageFavs = function (anchorFromEvent, fichaObj, callback, codigoAnuncio, realEstateAdId) {
        if (this.__favoritosDTO.UserIsLogged === "True") {
            anchorFromEvent = __setFavoritosAnchor.call(this, anchorFromEvent, codigoAnuncio);
            var self = this;
            jquery.ajax({
                type: "POST",
                dataType: "json",
                url: this.__favoritosDTO.UrlAnadirFavorito,
                data: this.__favoritosDTO.FavoritoDataAjax,
                success: function (oData) {
                    if (oData.status.code === 1) {
                        var svgFav = document.querySelector('.favlink > svg use');
                        if (anchorFromEvent) {
                            self.__anchorElement = anchorFromEvent;
                        }

                        if (typeof callback === 'function') {
                            var type = '';

                            if (self.__anchorElement.className.indexOf('favlink addfavimg') > -1 || self.__anchorElement.className.indexOf('fav-heart-link abs-center addfavimg') > -1 || self.__anchorElement.className.indexOf('fav-heart-link button-transparent abs-center addfavimg') > -1) {
                                type = 'add';
                            } else {
                                type = 'delete';
                            }
                            callback.call(fichaObj, self.__anchorElement, type, oData.status);
                        }
                        if (!self.__isFicha) {
                            realEstateAdId = self.__anchorElement.getAttribute('data-realestateadid');
                        }
                        if (self.__anchorElement.className.indexOf('favlink addfavimg') > -1 || self.__anchorElement.className.indexOf('fav-heart-link abs-center addfavimg') > -1 || self.__anchorElement.className.indexOf('fav-heart-link button-transparent abs-center addfavimg') > -1) {
                            jquery.publish(HabEvents.EventsEnum.FavoritoAnadirAccion);
                            var selectorGtm;
                            if (self.__isFicha) {
                                selectorGtm = "#ficha";
                            } else {
                                selectorGtm = self.__anchorElement.id.replace("fav", ".fid");
                            }
                            
                            if (svgFav) {
                                self.__anchorElement.children[0].classList.add("ocultar");
                                self.__anchorElement.children[1].classList.remove("ocultar");
                            } else {
                                self.__anchorElement.children[0].className = "sprite addfavorito ico-fav-active ";
                            }
                            self.__anchorElement.className = "favlink delfavimg fav-heart-link abs-center detail-buttons-icons detail-buttons-icons-fav";
                            jquery('#js-wide-fav').addClass('ico-fav-active');
                            var hrefFavAdd = self.__anchorElement.getAttribute('data-href');
                            self.__anchorElement.setAttribute('data-href', __getFavoritoHref.call(this, hrefFavAdd));
                            self.__favoritosDTO.UrlAnadirFavorito = self.__anchorElement.getAttribute('data-href');
                            if (self.__isFicha) {
                                __manageAlertasFicha.call(this, self.__favoritosDTO);
                            }
                            else {
                                __manageAlertasLista.call(this, self.__favoritosDTO);
                            }
                            jquery.publish(HabEvents.EventsEnum.FavoritoAnadido, [selectorGtm, realEstateAdId]);
                        }
                        else {
                            jquery.publish(HabEvents.EventsEnum.FavoritoEliminarAccion);
                            var selectorEliminarGtm;
                            if (self.__isFicha) {
                                selectorEliminarGtm = "#ficha";
                            } else {
                                selectorEliminarGtm = self.__anchorElement.id.replace("fav", ".fid");
                            }
                            if (svgFav) {
                                self.__anchorElement.children[0].classList.remove("ocultar");
                                self.__anchorElement.children[1].classList.add("ocultar");
                            } else {
                                self.__anchorElement.children[0].className = "sprite";
                                self.__anchorElement.className = "favlink addfavimg fav-heart-link button-transparent abs-center";
                            }
                            self.__anchorElement.className = "favlink addfavimg fav-heart-link abs-center detail-buttons-icons";
                            jquery('#js-wide-fav').removeClass('ico-fav-active');
                           
                            var hrefFavRemove = self.__anchorElement.getAttribute('data-href');
                            self.__anchorElement.setAttribute('data-href', __getFavoritoHref.call(this, hrefFavRemove));
                            self.__favoritosDTO.UrlAnadirFavorito = self.__anchorElement.getAttribute('data-href');
                            if (self.__isFicha) {
                                __manageAlertasFicha.call(this, self.__favoritosDTO);
                            }
                            else {
                                __manageAlertasLista.call(this, self.__favoritosDTO);
                            }
                            jquery.publish(HabEvents.EventsEnum.FavoritoEliminado, [selectorEliminarGtm, realEstateAdId]);
                        }
                    }
                    else {
                        alert("Se ha producido un error al agregar/eliminar un favorito.");
                    }

                },
                error: function (jqXHR, textStatus) {
                    console.log(jqXHR + " " + textStatus);
                    window.location = __getHabitacliaLogInUrl(self.__anchorElement, anchorFromEvent, self.__favoritosDTO.UrlLogin);
                }
            });
        }
        else {
            if (this.__anchorElement || anchorFromEvent) {
                window.location = __getHabitacliaLogInUrl(this.__anchorElement, anchorFromEvent, this.__favoritosDTO.UrlLogin);
            }
        }
    };

    var __saveRate = function (idReg, rate, fichaObj, callback, errCallback, domElement) {
        jquery.ajax({
            url: this.__favoritosDTO.UrlRateFav,
            type: 'POST',
            data: {
                idReg: idReg,
                rate: rate
            },
            success: function () {
                if (typeof callback === 'function') {
                    callback.call(fichaObj, domElement);
                }
            },
            error: function () {
                if (typeof errCallback === 'function') {
                    errCallback.call(fichaObj, domElement);
                }
            }
        });
    };

    var __saveComment = function (idReg, comment, fichaObj, callback, errCallback, domElement) {

        jquery.ajax({
            url: this.__favoritosDTO.UrlCommentFav,
            type: 'POST',
            data: {
                IdReg: idReg,
                Comment: comment
            },
            success: function () {
                if (typeof callback === 'function') {
                    callback.call(fichaObj, domElement);
                }
            },
            error: function () {
                if (typeof errCallback === 'function') {
                    errCallback.call(fichaObj, domElement);
                }
            }
        });
    };

    var __getHabitacliaLogInUrl = function (anchorElement, anchorFromEvent, baseUrlLogin) {
        if (anchorElement) {
            return baseUrlLogin;
        }
        else {
            var favoritoUrl = anchorFromEvent.getAttribute('data-href');
            var codEmp = HabUtils.GetURLParameterFromGivenURL('codEmp', favoritoUrl);
            var codInm = HabUtils.GetURLParameterFromGivenURL('codInm', favoritoUrl);
            var codigoAnuncio = HabUtils.GetCodigoAnuncio(codEmp, codInm);
            var loginUrl = baseUrlLogin + encodeURIComponent("&codigo=" + codigoAnuncio);
            return loginUrl;
        }
    };

    var __setFavoritosAnchor = function (anchorFromEvent, codigoAnunion) {

        let href;
        if (anchorFromEvent) {
            href = anchorFromEvent.getAttribute('data-href');
        }
        else if (codigoAnunion && codigoAnunion !== '') {
            var favoritoId = "fav" + codigoAnunion;
            var foundAnchor = document.getElementById(favoritoId);
            anchorFromEvent = foundAnchor;
            href = foundAnchor.dataset.href;
        }
        this.__favoritosDTO.UrlAnadirFavorito = href;
        this.__favoritosDTO.FavoritoDataAjax = HabUtils.GetQueryStringFromGivenURL(href);

        return anchorFromEvent;
    };

    var __getFavoritoHref = function (favoritoHref) {
        var hrefResult;
        if (favoritoHref && favoritoHref !== undefined) {
            /*jshint eqeqeq:false*/
            if (favoritoHref.match("addAlInm" + "$") == "addAlInm") {
                hrefResult = favoritoHref.replace("addAlInm", "removeFav");
            }
            else {
                hrefResult = favoritoHref.replace("removeFav", "addAlInm");
            }
            return hrefResult;
        }
    };

    var __manageAlertasFicha = function (favoritosDTO) {
        var anchorFavoritoFicha = document.getElementById("linkFavorito");
        if (anchorFavoritoFicha && favoritosDTO.textoAlerta) {
            var anchorAlerta = document.getElementById('linkAlerta');
            if (anchorFavoritoFicha.className === "favlink addfavimg fav-heart-link abs-center") {
                var textnodeAlerta = '<span id="js-txt-avisamesi">' + favoritosDTO.textoAlerta + '</span>';
                anchorAlerta.href = favoritosDTO.urlAddAlerta;
                anchorAlerta.className = 'avisame click notify notify-grey';
                anchorAlerta.title = favoritosDTO.textoAlerta;
                if (jquery('#js-txt-avisamesi').text(favoritosDTO.textoAlerta)) {
                    jquery('#js-txt-avisamesi').text(favoritosDTO.textoAlerta);
                } else {
                    jquery('#linkAlerta').append(textnodeAlerta);
                }
            }
            else {
                anchorAlerta.href = favoritosDTO.urlRemoveAlerta;
                anchorAlerta.className = 'delavisame click notify notify-orange';
                anchorAlerta.title = 'Eliminar alerta';
                jquery('#js-txt-avisamesi').html('');
            }
        }
    };

    var __manageAlertasLista = function (favoritosDTO) {
        let codInm = HabUtils.GetURLParameterFromGivenURL('codInm', favoritosDTO.UrlAnadirFavorito);
        let buttonProducto = document.getElementById(codInm);
        if (buttonProducto) {
            if (buttonProducto.className === "button-transparent js-notify notify notify-grey") {
                buttonProducto.className = "button-transparent js-notify notify notify-orange";
            }
            else {
                buttonProducto.className = "button-transparent js-notify notify notify-grey";
            }
        }
    };

    var __isFicha = function () {
        var element = document.getElementById("ficha");
        if (element) {
            return true;
        }
        else {
            return false;
        }
    };

    var __setIsUuserLogged = function (isUserLogged) {
        this.__favoritosDTO.UserIsLogged = isUserLogged;
    };


    Favoritos.prototype = {
        constructor: Favoritos,
        ManageFavs: __manageFavs,
        SaveRate: __saveRate,
        SaveComment: __saveComment,
        SetIsUuserLogged: __setIsUuserLogged
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = new Favoritos(FavoritosDTO);
    }
    else {
        window.Favoritos = new Favoritos(FavoritosDTO);
    }
}());